export enum TransactionStatus {
  Initialized = "Inintialized",
  Cancelled = "Cancelled",
  Paid = "Paid",
  Failed = "Failed",
  Error = "Error",
}
